import React from 'react';
import { connect } from 'react-redux';
import HeadingBlock from '$/components/global/heading';
import DataSiteDocumentsGrid from '$/components/data-site-documents-grid';
import { toastSuccess, toastError } from '$/store/toast/actions';
import { downloadFile } from '$/store/export/actions';

interface IDataSiteDocumentsProps {
  dispatchToastError: (message: string) => void;
  dispatchToastSuccess: (message: string) => void;
  dispatchDownloadDocument: (blob: Blob, fileName: string) => void;
}

const DataSiteDocuments: React.FC<IDataSiteDocumentsProps> = props => {
  const { dispatchToastError, dispatchToastSuccess, dispatchDownloadDocument } = props;
  return (
    <React.Fragment>
      <section>
        <div>
          <HeadingBlock title={'Data Site Documents'} />
          <DataSiteDocumentsGrid
            dispatchToastError={dispatchToastError}
            dispatchToastSuccess={dispatchToastSuccess}
            dispatchDownloadDocument={dispatchDownloadDocument}
          />
        </div>
      </section>
    </React.Fragment>
  );
};

function mapDispatchToProps(dispatch: any) {
  return {
    dispatchToastError: (message: string) => dispatch(toastError(message)),
    dispatchToastSuccess: (message: string) => dispatch(toastSuccess(message)),
    dispatchDownloadDocument: (blob: Blob, fileName: string) => dispatch(downloadFile(blob, fileName)),
  };
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(DataSiteDocuments);
